// extracted by mini-css-extract-plugin
export default {"button":"qk-z","reviewSort":"rk-z"};